import { supportedCountries } from "../phone-input/countries";

export const findCountryCodeGivenCountryName = (countryName: string) => {
  return (
    supportedCountries.find(
      (c) => c.name.toLowerCase() === countryName.toLowerCase()
    )?.code ?? ""
  );
};

export const findCountryNameGivenCountryCode = (countryCode: string) => {
  return (
    supportedCountries.find(
      (c) => c.code.toLowerCase() === countryCode.toLowerCase()
    )?.name ?? ""
  );
};
